// src/config/siteConfig.js
export const CAL_LINK = "https://cal.com/meetanindya";
